import {
    MemberFieldApiData,
    MemberField,
    MemberFieldValueType,
    SysMemberFieldKey
} from '../interfaces';
import { find, forEach, isString, map, trim } from './lodash';
import { isObjectEmpty } from './common';

/**
 * 系统字段key转换为旧key
 * @param newKey
 */
export const toOldSysMemberFieldKey = (newKey: string) => {
    switch (newKey) {
        case SysMemberFieldKey.Nickname:
            return 'nickname';
        case SysMemberFieldKey.Username:
            return 'username';
        case SysMemberFieldKey.Phone:
            return 'phone';
        case SysMemberFieldKey.Email:
            return 'email';
        case SysMemberFieldKey.Dept:
            return 'dept';
        case SysMemberFieldKey.Role:
            return 'role';
        default:
            return newKey;
    }
};

/**
 * 系统字段key转换为新key
 * @param oldKey
 */
export const toNewSysMemberFieldKey = (oldKey: string) => {
    switch (oldKey) {
        case 'nickname':
            return SysMemberFieldKey.Nickname;
        case 'username':
            return SysMemberFieldKey.Username;
        case 'phone':
            return SysMemberFieldKey.Phone;
        case 'email':
            return SysMemberFieldKey.Email;
        case 'dept':
            return SysMemberFieldKey.Dept;
        case 'role':
            return SysMemberFieldKey.Role;
        default:
            return oldKey;
    }
};

/**
 * 获取成员字段默认/空值
 *
 * @param field
 * @param mode default表示获取默认值，empty表示获取空值
 */
const initMemberFieldValue = (field: MemberFieldApiData, mode: 'default' | 'empty' = 'default') => {
    const isEmptyMode = mode === 'empty';
    switch (field.type) {
        case MemberFieldValueType.Combo: {
            if (isEmptyMode) {
                return null;
            }
            const option = find(field.items, (item) => !!item.selected);
            return option ? option.value : null;
        }
        case MemberFieldValueType.ComboCheck: {
            if (isEmptyMode) {
                return [];
            }
            const defaultValue: string[] = [];
            forEach(field.items, (item) => {
                if (item.selected) {
                    defaultValue.push(item.value);
                }
            });
            return defaultValue;
        }
        case MemberFieldValueType.Text:
            return '';
        case MemberFieldValueType.DeptGroup:
        case MemberFieldValueType.UserGroup:
            return [];
        case MemberFieldValueType.Datetime:
        case MemberFieldValueType.Number:
        case MemberFieldValueType.Dept:
        case MemberFieldValueType.User:
        default:
            return null;
    }
};

export const formatMemberFieldValue = (field: MemberField, value?: any) => {
    switch (field.valueType) {
        case MemberFieldValueType.User:
        case MemberFieldValueType.Dept:
            return value ? value._id : null;
        case MemberFieldValueType.UserGroup:
        case MemberFieldValueType.DeptGroup:
            return map(value, '_id');
        default:
            return value;
    }
};
export const getMemberFieldCommitValue = (
    getField: (key: string) => MemberField | undefined,
    pfValue?: Record<string, any>,
    skipEmpty?: boolean
) => {
    const result: Record<string, any> = {};
    forEach(pfValue, (value, key) => {
        const trimValue = isString(value) ? trim(value) : value;
        if (skipEmpty && isObjectEmpty(trimValue)) {
            return;
        }
        const field = getField(key);
        result[key] = field ? formatMemberFieldValue(field, trimValue) : trimValue;
    });
    return result;
};

export const formatMemberField = (field: MemberFieldApiData): MemberField => {
    return {
        label: field.name,
        key: field.widget_name,
        valueType: field.type,
        required: field.required,
        maxWordCount: field.type === MemberFieldValueType.Text ? 50 : undefined,
        format: field.type === MemberFieldValueType.Datetime ? 'yyyy-MM-dd' : undefined,
        emptyValue: initMemberFieldValue(field, 'empty'),
        defaultValue: initMemberFieldValue(field, 'default'),
        options: field.items
    };
};

export const getMemberFieldMap = (fields: MemberField[]) => {
    const fieldMap: Record<string, MemberField> = {};
    forEach(fields, (field) => {
        fieldMap[field.key] = field;
    });
    return fieldMap;
};
